import { render, staticRenderFns } from "./count.vue?vue&type=template&id=47674af8&scoped=true&"
import script from "./count.vue?vue&type=script&lang=js&"
export * from "./count.vue?vue&type=script&lang=js&"
import style0 from "./count.vue?vue&type=style&index=0&id=47674af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47674af8",
  null
  
)

export default component.exports